import React, { useState } from "react";
import vg from "../assets/vg.png";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

const Contact = () => {
  const [text, setText] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [disablBtn, setDisableBtn] = useState(false);

  const onChangeHandler = (event) => {
    setText({ ...text, [event.target.name]: event.target.value });
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      await addDoc(collection(db, "contacts"), text);
      toast.success("Message Sent");
      setDisableBtn(false);
      setText({...text,email:"",message:"",name:""})
    } catch (error) {
      toast.error("Failed");
      console.log(error);
      setDisableBtn(false);
    }
  };
  // to use toast  we have to import <Toast/> in app or index

  const animination = {
    form: {
      initial: {
        x: "-100%",
        opacity: 0,
      },
      whileInView: {
        x: 0,
        opacity: 1,
      },
    },
    button: {
      initial: {
        y: "-100%",
        opacity: 0,
      },
      whileInView: {
        y: 0,
        opacity: 1,
      },
      transition: {
        delay: 0.5,
      },
    },
  };

  return (
    <div id="contact">
      <section>
        <motion.form {...animination.form} onSubmit={onSubmitHandler}>
          <h2>Contact Me</h2>
          <input
            type="text"
            placeholder="Name"
            required
            name="name"
            value={text.name}
            onChange={onChangeHandler}
          />
          <input
            type="email"
            placeholder="Email"
            required
            name="email"
            value={text.email}
            onChange={onChangeHandler}
          />
          <input
            type="text"
            placeholder="Your message"
            required
            name="message"
            value={text.message}
            onChange={onChangeHandler}
          />

          <motion.button
            {...animination.button}
            disabled={disablBtn}
            className={disablBtn ? "disableBtn" : ""}
            type="submit"
          >
            Send
          </motion.button>
        </motion.form>
      </section>
      <aside>
        <img src={vg} alt="graphics" />
      </aside>
    </div>
  );
};

export default Contact;
